import TechnicalConditionIcon from './component'

export default TechnicalConditionIcon
